import './administrative-dashboard';
import './manage-point-inaccuracy-list.js';
import './manage-media-list';
import './manage-ocr-settings';
import './manage-organization-list';
import './manage-organization-submission-list';
import './manage-pet-list';
import './manage-redemption-list';
import './manage-salesforce-import-list';
import './manage-transaction-list';
import './manage-user-list';
import './manage-user-activity-list';
import './manage-white-list';
import './manage-onbe-downtime-window';
import './user-profile';
import './components';
import './story-list';
import './developer-documentation';